import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type { Store } from '@warp-drive/core';
import { getUserItems, getUserSources } from '../builders/profile.ts';
import type { UserItem } from '../schemas/user-item.ts';
import type { UserSource } from '../schemas/user-source.ts';
import type { PaginationMeta } from '../utils/api-types.ts';

export default class IndexRoute extends Route {
  @service declare store: Store;

  async model() {
    try {
      // Personal lists that change right after submitting a URL — always
      // refetch (also makes pull-to-refresh actually refresh).
      const [itemsResult, sourcesResult] = await Promise.all([
        this.store.request({
          ...getUserItems({ pageSize: '6' }),
          cacheOptions: { reload: true },
        }),
        this.store.request({
          ...getUserSources({ pageSize: '6' }),
          cacheOptions: { reload: true },
        }),
      ]);

      const itemsJson = itemsResult.content as {
        data?: UserItem[];
        meta?: PaginationMeta;
      };
      const sourcesJson = sourcesResult.content as {
        data?: UserSource[];
        meta?: PaginationMeta;
      };

      return {
        recentSources: sourcesJson.data ?? [],
        recentItems: itemsJson.data ?? [],
        itemCount: itemsJson.meta?.total ?? 0,
        sourceCount: sourcesJson.meta?.total ?? 0,
        loadError: false as const,
      };
    } catch {
      return {
        recentSources: [] as UserSource[],
        recentItems: [] as UserItem[],
        itemCount: 0,
        sourceCount: 0,
        loadError: true as const,
      };
    }
  }
}
